import { axiosChartInstance } from "config";
import { OrderFormElementType } from "enums";
import { useAxiosQuery } from "hooks";
import { OrderElementResponse } from "modules/order-list/types/order-element-response";

type OrderFormElementTypeGroup = OrderFormElementType | "EKG";

function useOrderListElements(elementType: OrderFormElementTypeGroup) {
  return useAxiosQuery(["orderListElements", elementType], () =>
    axiosChartInstance.get<OrderElementResponse[]>(
      `v1/order-form/elements/filter?formElementType=${elementType}`,
      {}
    )
  );
}
export { useOrderListElements };
export type { OrderFormElementTypeGroup };
